import { parent } from ".";

export const getUser = () => {
  parent.postMessage({ playdeck: { method: 'getUserProfile' } }, '*');
};
